/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".dummy_1067c52f{background:blue}\n"}]);
export const dummy = "dummy_1067c52f";